import { ISuperPacmanDaysToAmountItem } from "@/types/ISuperPacman";

/**
 * Returns the `dateUnlockedUntil` (in milliseconds) of the last `daysToAmount`
 * row whose amount is at or below the typed amount, mirroring the SuperPacman
 * "next valid through" rule. Falls back to the first row when the amount is
 * below every row, and returns `null` when there are no rows.
 */
export function nextValidThroughMs(daysToAmount: ISuperPacmanDaysToAmountItem[], amount: number): number | null {
  if (!daysToAmount.length) return null;
  let index = 0;
  for (let i = 0; i < daysToAmount.length; i++) {
    if (amount >= Number(daysToAmount[i].amount)) index = i;
  }
  return daysToAmount[index].dateUnlockedUntil * 1000;
}
